import axios from 'axios'

window.axios = axios

axios.defaults.headers.common['Token'] = 'Bearer ' + localStorage.getItem('accessToken')

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

axios.defaults.headers.common['Content-Type'] = 'application/json'

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

/*
axios.interceptors.response.use(function (response) {

	return response;

}, function (error) {

	
	if (401 === error.response.status && location.href.split('/')[location.href.split('/').length - 1] !== 'login') {

		localStorage.removeItem('accessToken')

		location.href = '/login'

	} else {

		return Promise.reject(error);

	}

})
*/